import { byBrand } from "@repo/tailwind-config/brand";
import Image from "next/image";
import kinsaHeaderImage from "public/kinsa-header.svg";
import { DismissCloseButton } from "../DismissCloseButton";

export function HomeLoadingSkeleton() {
  return byBrand({
    owlet: (
      <div className="min-h-screen bg-[#060727]">
        {/* Header — matches OwletHomeWizard owletNavTheme */}
        <header className="fixed top-0 left-0 right-0 z-10 bg-[rgba(6,7,39,0.75)] backdrop-blur-[7.5px] px-4 pt-[calc(var(--felt-safe-area-top)+16px)] pb-4 flex items-center justify-between">
          <div className="w-10" />
          <Image
            src="/icons/owlet/logo.png"
            alt="Owlet OnCall"
            height={18}
            width={128}
            priority
          />
          <DismissCloseButton />
        </header>
      </div>
    ),
    default: (
      <div className="min-h-screen bg-white">
        {/* Header — matches BrandedNavHeader styling */}
        <header className="fixed top-0 left-0 right-0 z-10 pt-[calc(var(--felt-safe-area-top)+16px)] bg-white border-b-[0.5px] border-slate-100 pb-4 min-h-11 flex items-center justify-between">
          <div className="w-10" />
          <Image src={kinsaHeaderImage} alt="Kinsa Logo" height={24} priority />
          <DismissCloseButton />
        </header>
      </div>
    ),
  });
}
